<template>

    <div class="row">
        <div class="col-md-6">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Instellingen</h2>
                    <div class="box-tools">
                        <router-link
                            class="btn btn-primary btn-xs"
                            :to="{name:'hr.users.edit', params:{uuid:getHrUser.uuid}}"
                            v-tooltip.bottom="'Gebruiker bewerken'"
                        >
                            <i class="mdi mdi-pencil"></i>
                            <span class="sr-only">Gebruiker bewerken</span>
                        </router-link>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-md-6">Actief</th>
                                <td class="col-md-6">
                                    <toggle-active
                                        :current-active="getHrUser.active"
                                        :toggle-url="route('api.v1.users.toggleactive', {user_uuid:getHrUser.uuid}, false)"
                                    ></toggle-active>
                                </td>
                            </tr>
                            <tr>
                                <th>Code</th>
                                <td>{{ getHrUser.code }}</td>
                            </tr>
                            <tr>
                                <th>Gebruikersnaam</th>
                                <td>
                                    <router-link
                                        :to="{name:'hr.users.changeusername', params:{uuid:getHrUser.uuid}}"
                                        class="btn btn-default btn-xs pull-right"
                                        v-tooltip="'Gebruikersnaam wijzigen'"
                                    >
                                        <i class="mdi mdi-pencil"></i>
                                        <span class="sr-only">Gebruikersnaam wijzigen</span>
                                    </router-link>
                                    {{ getHrUser.username }}
                                </td>
                            </tr>
                            <tr>
                                <th>E-mailadres (Zakelijk)</th>
                                <td>{{ getHrUser.email }}</td>
                            </tr>
                            <tr>
                                <th>Gebruikersgroep</th>
                                <td v-if="!getHrUser.usergroup">&ndash;</td>
                                <td v-else>
                                    <router-link
                                        :to="{name:'hr.usergroups.show', params:{uuid:getHrUser.usergroup.uuid}}"
                                        class="btn btn-default btn-xs pull-right"
                                        v-tooltip="'Gebruikersgroep bekijken'"
                                    >
                                        <i class="mdi mdi-eye"></i>
                                        <span class="sr-only">Gebruikersgroep bekijken</span>
                                    </router-link>
                                    {{ getHrUser.usergroup.name }}
                                </td>
                            </tr>
                            <tr v-if="getHrUser.contract_usergroup">
                                <th>
                                    Gebruikersgroep (contractueel)
                                    <i
                                        class="mdi mdi-help-circle"
                                        v-tooltip="'Het uurtarief van deze gebruiker wordt berekend over de gebruikersgroep in het huidige actieve contract'"
                                    ></i>
                                </th>
                                <td>
                                    <router-link
                                        :to="{name:'hr.usergroups.show', params:{uuid:getHrUser.contract_usergroup.uuid}}"
                                        class="btn btn-default btn-xs pull-right"
                                        v-tooltip="'Gebruikersgroep bekijken'"
                                    >
                                        <i class="mdi mdi-eye"></i>
                                        <span class="sr-only">Gebruikersgroep bekijken</span>
                                    </router-link>
                                    {{ getHrUser.contract_usergroup.name }}
                                </td>
                            </tr>
                            <tr>
                                <th>Team</th>
                                <td v-if="!getHrUser.team">&ndash;</td>
                                <td v-else>{{ getHrUser.team.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Persoonsgegevens</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-md-6">Naam</th>
                                <td class="col-md-6">{{ getHrUser.fullname }}</td>
                            </tr>
                            <tr>
                                <th>Voornaam</th>
                                <td>{{ getHrUser.firstname }}</td>
                            </tr>
                            <tr>
                                <th>Tussenvoegsels</th>
                                <td>{{ getHrUser.middlename }}</td>
                            </tr>
                            <tr>
                                <th>Achternaam</th>
                                <td>{{ getHrUser.lastname }}</td>
                            </tr>
                            <tr>
                                <th>Adres</th>
                                <td>{{ getHrUser.address }}</td>
                            </tr>
                            <tr>
                                <th>Postcode</th>
                                <td>{{ getHrUser.zipcode }}</td>
                            </tr>
                            <tr>
                                <th>Plaats</th>
                                <td>{{ getHrUser.city }}</td>
                            </tr>
                            <tr>
                                <th>Land</th>
                                <td>{{ getHrUser.country }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Contactgegevens</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-md-6">Telefoonnummer</th>
                                <td class="col-md-6">{{ getHrUser.phone }}</td>
                            </tr>
                            <tr>
                                <th>Mobiel</th>
                                <td>{{ getHrUser.mobile }}</td>
                            </tr>
                            <tr>
                                <th>E-mailadres (Priv&eacute;)</th>
                                <td>{{ getHrUser.private_email }}</td>
                            </tr>
                            <tr>
                                <th>{{ lang.get('global.tel_emergency') }}</th>
                                <td>{{ getHrUser.tel_emergency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Overig</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-md-6">BSN</th>
                                <td class="col-md-6">{{ getHrUser.bsn }}</td>
                            </tr>
                            <tr>
                                <th>Geboortedatum</th>
                                <td>{{ birthday }}</td>
                            </tr>
                            <tr>
                                <th>Geboorteplaats</th>
                                <td>{{ getHrUser.birthplace }}</td>
                            </tr>
                            <tr>
                                <th>Geboorteland</th>
                                <td>{{ getHrUser.birthcountry }}</td>
                            </tr>
                            <tr>
                                <th>Banknaam</th>
                                <td>{{ getHrUser.bank_name }}</td>
                            </tr>
                            <tr>
                                <th>IBAN</th>
                                <td>{{ getHrUser.iban_number }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import ToggleActive from "../../../components/Users/ToggleActive";
import moment from 'moment';
import Lang from '../../../Lang';


export default {

    components: {
        ToggleActive,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
            'moduleIsActive',
        ]),

        birthday() {
            return moment(this.getHrUser.birthday).format('DD-MM-YYYY');
        },
    },

    metaInfo: {
        title:'Gebruiker bekijken',
    },

    name:'HrUsersShow',

    data() {
        return {
            lang: Lang,
        }
    }
}

</script>
